import { render, staticRenderFns } from "./testimonial-card1.vue?vue&type=template&id=7d1c4a97&scoped=true"
import script from "./testimonial-card1.vue?vue&type=script&lang=js"
export * from "./testimonial-card1.vue?vue&type=script&lang=js"
import style0 from "./testimonial-card1.vue?vue&type=style&index=0&id=7d1c4a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1c4a97",
  null
  
)

export default component.exports